var file_upload_viewer_default = {
  "fontElementMap": "j6Xlj",
  "file_upload_container": "rANrl",
  "file_upload_link": "PaFuZ",
  "file_upload_error_container": "p8BUv",
  "file_upload_file_info": "nX8m6",
  "file_upload_type_icon": "c5VIG",
  "file_upload_status_icon_container": "QTGLR",
  "file_upload_status_icon": "TtWZc",
  "file_upload_description": "UgHVq",
  "file_upload_name_container": "yGXSb",
  "file_upload_name": "CgAYt",
  "file_upload_extension": "LlJR4",
  "file_loader_icon": "SRQho",
  "file_upload_icon_frame": "iVdxZ",
  "file_upload_icon_background": "FGc0Q"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
